export default "__VITE_ASSET__B_sMEEl2__"